import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback } from 'react';

import { EXCESS_TYPES, PREMIUM_REVIEW_TOGGLE_STYLE } from '../../../../../ahm-constants/ui';
import { Label, PaymentOption, PaymentOptionsWrapper, SoftBundleListbox } from '../../choose-your-cover/styles';
import { ProductType } from '../../../../../types/product';
import CustomerActions from '../../../../../actions/customer';
import getFrequencyOptions from '../../../../../utils/get-frequency-options';
import hospitalExcessToOptions from '../../../../../utils/hospital-excess-to-options';
import PremiumReviewToggle from '../../../../../components/premium-review-toggle-wrapper';
import selectCustomer from '../../../../../selectors/select-customer';

const PaymentToggles = ({ productType }: { productType: ProductType['type'] }) => {
  const { frequency, hospitalExcess } = useSelector(selectCustomer);

  const dispatch = useDispatch();

  const onChangeFrequency = useCallback(
    (newFrequency) => {
      dispatch(CustomerActions.changeFrequency(newFrequency));
    },
    [dispatch],
  );

  const onChangeExcess = useCallback(
    (excess) => {
      dispatch(CustomerActions.changeHospitalExcess(excess));
    },
    [dispatch],
  );

  return (
    <PaymentOptionsWrapper>
      <PremiumReviewToggle
        hasEvenSpacing
        hasMargin={false}
        showBackground={false}
        type={PREMIUM_REVIEW_TOGGLE_STYLE.SOFT_BUNDLE_PAGE}
      />
      <Label>Paying</Label>
      <PaymentOption>
        <SoftBundleListbox
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call.
          id="frequency"
          label="frequency"
          ariaLabel="frequency"
          value={frequency}
          options={getFrequencyOptions({ endText: 'ly' })}
          onChange={onChangeFrequency}
        />
      </PaymentOption>
      {productType === PRODUCT_TYPE.HOSPITAL && (
        <>
          <Label>Excess</Label>
          <PaymentOption>
            <SoftBundleListbox
              label="excess"
              ariaLabel="excess"
              value={hospitalExcess}
              options={hospitalExcessToOptions(EXCESS_TYPES)}
              onChange={onChangeExcess}
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call.
              softBundlePage
            />
          </PaymentOption>
        </>
      )}
    </PaymentOptionsWrapper>
  );
};

export default PaymentToggles;
